import * as types from "../actions/index";
export default function(state = 0, action) {
  switch (action.type) {
    case types.SET_LOAD_COUNT:
      return action.payload;
    // no default
  }
  return state;
}
